import { render, staticRenderFns } from "./Major.vue?vue&type=template&id=af66c8dc&scoped=true&"
import script from "./Major.vue?vue&type=script&lang=js&"
export * from "./Major.vue?vue&type=script&lang=js&"
import style0 from "./Major.vue?vue&type=style&index=0&id=af66c8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af66c8dc",
  null
  
)

export default component.exports